import {Scene} from './scene';
import {Person} from './person';

export enum SectionType {
  Scenes,
  Persons
}

export class Section {

  displayName: string;
  items: any[] = [];

  constructor(public data: any, public type: SectionType) {
    const json: JSON = data;

    this.displayName = json['displayName'];

    if (type === SectionType.Scenes) {
      this.items = Array<Scene>();
      if (json['scenes']) {
        for (const s of json['scenes']) {
          this.items.push(new Scene(s));
        }
      }
    }

    if (type === SectionType.Persons) {
      this.items = Array<Person>();
      if (json['persons']) {
        for (const s of json['persons']) {
          this.items.push(new Person(s));
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/section.ts